import { useState, useEffect } from 'react';

export function useTypewriter(
  text: string,
  delay: number = 50,
  onComplete?: () => void
) {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (currentIndex >= text.length) {
      setIsTyping(false);
      onComplete?.();
      return;
    }

    const timeout = setTimeout(() => {
      setDisplayText(prev => prev + text[currentIndex]);
      setCurrentIndex(prev => prev + 1);
    }, delay);

    return () => clearTimeout(timeout);
  }, [text, delay, currentIndex, onComplete]);

  return { displayText, isTyping };
}